import React, { useState, Fragment, useRef } from 'react';
import Main from '../Components/Main';
import Seo from '../Components/Seo';
import axios from 'axios'
import { ExclamationIcon } from '@heroicons/react/solid'
import { Dialog, Transition } from '@headlessui/react'
import RequestFeedButton from '../Components/RequestFeedButton';

// const people = [
//   { name: 'Jane Cooper', title: 'Regional Paradigm Technician', role: 'Admin', email: 'jane.cooper@example.com' },
//   { name: 'Cody Fisher', title: 'Product Directives Officer', role: 'Owner', email: 'cody.fisher@example.com' },
//   // More people...
// ]

export default function Request() {
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)
  const [mad, setMad] = useState(2);
  const [numFPs, setNumFP] = useState(30);
  const [tvl, setTvl] = useState(10000);
  const [results, setDisplayResults] = useState(false)
  const [data, setData] = useState({})
  const [profit, setProfit] = useState(30)
  const [annualizedReturns, setAnnualizedReturns] = useState([])
  const [deviation, setDeviation] = useState([])
  const [loading, setLoading] = useState(false)

  const handleCalculate = async (e) => {
    e.preventDefault()
    setLoading(true)
    const result = await
    axios
      .post('https://algoracle-python-feed-api.herokuapp.com/api/v1/simulate', {
        'days': 2,
        tvl,
        'feeds': numFPs,
        'goals': 0.25,
        mad,
        'users': 50,
        'k': 2,
        'big_loss_k': 3
      });
    if (result.data.data['Annualized Returns (%)'].length > 0) {
      setData(result.data.data);
      let profit = await JSON.parse(result.data.data['Annualized Returns (%)'])
      let deviationRaw = await JSON.parse(result.data.data['Std Dev of Feed'])
      setAnnualizedReturns(profit)
      setDeviation(deviationRaw)
      // setProfit(result.data.data['Annualized Returns (%)'][0])
      setDisplayResults(true);
      setLoading(false)
    }
  }

  return (
    <Main>
      <Seo title="Request Feed" />
      <section className="bg-gray-100 text-neutral py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 items-center justify-items-center">
          <div className="max-w-xl p-6 mt-4 ">
            <h1 className="my-5 leading-normal text-4xl lg:text-5xl">
              <i className="font-semibold"> Interested in </i>
              <span className="font-bold text-lime-500 text-7xl">Starting a feed?</span>
            </h1>
            <p className="leading-normal">
              Goracle is extensible to provide any type of data. If you would like to see some data specific to your application that is not yet avaible on Goracle, use the tool below to get an idea of what you need to get it up and running.
            </p>
            <p className="leading-normal">
              However, we&apos;re happy to do the initial work before reaching mainnet, so feel free to send a request to our team.
            </p>
            <div className="mt-5">
              <a href="https://www.goracle.io/contact" target="_blank" 
                rel="noreferrer" className="button-primary">
                  Contact Us
              </a>
            </div>
          </div>
          <div className="max-w-md p-4 mt-2 flex justify-center">
            <img src="/images/robot-01.png" alt="Robot image" />
          </div>
        </div>
      </section>


      <div className="container max-w-5xl mx-auto m-8">
        <p className="text-center">
          Simply input the type of data that you have, and you will get optimal deposit and reward number. Share those numbers with the community, and once enough feeds commit to providing data by staking, node runners can then start pulling from their API.
        </p>
        <div className="px-4 flex justify-center   py-5 sm:p-6">
          <div className="rounded-md max-w-3xl mt-5 bg-yellow-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <ExclamationIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">Attention</h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>
                    This page is under construction and is a preview only. Follow the team on <a href="www.twitter.com/goracle"> Twitter </a> to get updates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <form className="w-full max-w-lg">
            <div className="w-full md:l px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-mad">
                Acceptable Median Absolute Deviation
              </label>
              <input onChange={e => setMad(e.target.value)} className="appearance-none block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-mad" type="number" placeholder={mad} />
              <a onClick={() => setOpen(true)} className="text-blue-500  text-xs italic">Click here to learn how to calculate.</a>
            </div>


            <div className="w-full md:l mt-10 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-tvl">
                Total Value Locked
              </label>
              <input onChange={e => setTvl(e.target.value)} className="appearance-none block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-tvl" type="number" placeholder={tvl} />
              <p className="text-xs italic">Total value the largest application using this feed will secure.</p>
            </div>

            <div className="w-full md:l mt-10 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-num-fps">
                Number of Feed Providers
              </label>
              <input onChange={e => setNumFP(e.target.value)} className="appearance-none block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-num-fps" type="number" placeholder={numFPs} />
              <a href="https://www.goracle.io/support" className="text-blue-500 text-xs italic">Learn more about providing feeds.</a>
            </div>
            <div className="mt-5">
              <button onClick={(e) => { handleCalculate(e) }} className="py-2 px-4 flex items-center justify-center font-semibold bg-lime-500 text-white rounded-sm hover:bg-lime-700">
                {loading && <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>}
                {loading ? 'Calculating' : 'Calculate'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {results && <> <div className="container max-w-5xl mx-auto m-8">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Results</h2>
        <div className="flex flex-col">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Input
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={2 % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">Deposit</td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{data['deposit'].toFixed(2)}</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className={2 % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">Profit for Quality Feed Provider</td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{profit} % </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className={2 % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">Number of Simulations</td>
                      <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">100,000 </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col container max-w-5xl mx-auto m-8">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Simulation Outcomes</h2>
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        Feed Provider #
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        Deviation
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        Annualized Return
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {annualizedReturns.map((returnItem, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">FP # {index}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{deviation[index]}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{returnItem.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </>
      }
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      Acceptable MAD - Instructions coming soon
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        The Acceptable median absolute deviation is a robust measure of a feed provider&apos;s Quality. To calculate this number, historical data is required to be analyzed. See the Goracle whitepaper for a detailed explanation on how this simulation page will be built out.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => setOpen(false)}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </Main>
  );
}
